import { type TagType, type TagTypeEnum } from '@repo/utils';

export const getTags = `
  query getTags(
    $tagTypes: [TagTypeEnum!],
    $tagName: String,
  ) {
    tags(tagTypes: $tagTypes, tagName: $tagName) {
      id
      name
      tagType
      sequence
    }
  }
`;

export interface GetTagsQueryType {
  tags: TagType[];
}

export interface GetTagsQueryVariables {
  tagTypes?: TagTypeEnum[];
  tagName?: string;
}
